// extracted by mini-css-extract-plugin
export var button = "Button-module--button--3x-IL";
export var button__text = "Button-module--button__text--37W9C";
export var button__icon = "Button-module--button__icon--2d3uZ";
export var button__icon_before = "Button-module--button__icon_before--1QIFq";
export var button__icon_after = "Button-module--button__icon_after--3iVVV";
export var button__loader = "Button-module--button__loader--24jqk";
export var button_onlyIcon = "Button-module--button_onlyIcon--2Yvah";
export var button_disabled = "Button-module--button_disabled--3j_6b";
export var button_loading = "Button-module--button_loading--2RNmp";
export var button_primary = "Button-module--button_primary--136Go";
export var button_secondary = "Button-module--button_secondary--2uF1N";
export var button_additional = "Button-module--button_additional--L1guf";
export var button_clear = "Button-module--button_clear--3srI0";
export var button_ghost = "Button-module--button_ghost--3XQUI";
export var button_icon = "Button-module--button_icon--1sXIG";